module.exports = __webpack_public_path__ + "static/media/createuser.53f53d8c.svg";